import { Card, Empty, Tooltip } from 'antd';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import '../../styles/file-list.css';

/*
 * FileListCard — a titled card of named files, each with a Preview (eye) and
 * Download action. Generic file-list chip UI (not tied to any one module) —
 * pass `onPreview` to wire it to whatever viewer the page already uses
 * (e.g. DocumentViewer). Falls back to an empty state when `files` is empty.
 */
export default function FileListCard({
  title = 'Proof',
  files = [],
  onPreview,
  emptyText = 'No files uploaded',
  className,
}) {
  if (!files.length) {
    return (
      <Card size="small" className={`znx-file-list__empty ${className ?? ''}`.trim()}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
      </Card>
    );
  }

  return (
    <Card size="small" title={title} className={`znx-file-list__card ${className ?? ''}`.trim()}>
      {files.map((file, index) => (
        <div className="znx-file-list__chip" key={file.url ?? index}>
          <span className="znx-file-list__name" title={file.name}>
            {file.name || 'File'}
          </span>
          <span className="znx-file-list__actions">
            {onPreview && (
              <Tooltip title="Preview">
                <button
                  type="button"
                  className="znx-file-list__btn"
                  onClick={() => onPreview(index)}
                  aria-label={`Preview ${file.name || 'file'}`}
                >
                  <EyeOutlined />
                </button>
              </Tooltip>
            )}
            <Tooltip title="Download">
              <a
                className="znx-file-list__btn"
                href={file.url}
                download={file.name}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Download ${file.name || 'file'}`}
              >
                <DownloadOutlined />
              </a>
            </Tooltip>
          </span>
        </div>
      ))}
    </Card>
  );
}
